<router-outlet></router-outlet>

<div class="tree-dialog" [ngClass]="!dialog.isActivated ? 'hidden': '' ">
  <router-outlet #dialog="outlet" name="treedialog" class="tree-dialog"></router-outlet>
</div>

<!-- footer menu -->
<app-footer *ngIf="footerAvailable" [user]="authService.user$.value"></app-footer>